import request from '@/utils/request'
import childRequest from '@/utils/childRequest'




export function wordAll(query) {
  return childRequest({
    url: `/oper/word/all`,
    method: 'get',
	params:query
  })
}
export function wantAll(query) {
  return childRequest({
    url: `/oper/want/all`,
    method: 'get',
	params:query
  })
}
 
export function findByUpDown(query) {
  return childRequest({
    url: `/oper/news/findByUpDown`,
    method: 'get',
	params:query
  })
}

export function columntTreelist(query) {
  return request({
    url: `/website/column/treelist`,
    method: 'get',
	params:query
  })
}

//关于我们道佑公告
export function noticelist(query) {
  return request({
    url: `/website/notice/list`,
    method: 'get',
	params:query
  })
}
export function consultingsave(query) {
  return request({
    url: `/website/consulting/save`,
    method: 'post',
	data:query
  })
}

export function listwebsite(query) {
  return childRequest({
    url: `/oper/complain/listwebsite`,
    method: 'get',
	params:query
  })
}


export function collectlist(query) {
  return childRequest({
    url: `/oper/collect/list`,
    method: 'get',
	params:query
  })
}
export function followdel(query) {
  return childRequest({
    url: `/oper/follow/del`,
    method: 'post',
	data:query
  })
}


export function followlist(query) {
  return childRequest({
    url: `/oper/follow/list`,
    method: 'get',
	params:query
  })
}


export function websitelist(query) {
  return childRequest({
    url: `/oper/evaluate/websitelist`,
    method: 'get',
	params:query
  })
}


export function authenticateList(query) {
  return request({
    url: `/oper/authenticate/list`,
    method: 'post',
	data:query
  })
}



export function loginregister(query) {
  return request({
    url: `/app/login/register`,
    method: 'post',
	data:query
  })
}


export function sendCode(query) {
  return request({
    url: `/app/login/sendCode`,
    method: 'post',
	data:query
  })
}


export function mediaList(query) {
  return request({
    url: `/website/media/list`,
    method: 'get',
	params:query
  })
}

export function findBySearchToPeiChang(query) {
  return childRequest({
    url: `/oper/news/findBySearchToPeiChang`,
    method: 'get',
	params:query
  })
}

export function findBySearch(query) {
  return childRequest({
    url: `/oper/news/findBySearch`,
    method: 'get',
	params:query
  })
}
export function judgementSelectList(query) {
  return request({
    url: `/sys/user/judgement/selectList`,
    method: 'get',
	params:query
  })
}
export function classificationList(query) {
  return childRequest({
    url: `/oper/classification/pagelist`,
    method: 'post',
    data:query
  })
}
export function merchantNormal(query) {
  return request({
    url: `/oper/merchant/webSiteNormal`,
    method: 'post',
	data:query
  })
}

export function selectStaffList(query) {
  return request({
    url: `/sys/user/staff/webSiteSelectStaffList`,
    method: 'get',
	params:query
  })
}


export function merchantlist(query) {
  return request({
    url: `/oper/merchant/webSiteList`,
    method: 'get',
	params:query
  })
}

export function summaryList(query) {
  return request({
    url: `/website/summary/list`,
    method: 'get',
	params:query
  })
}


export function honorList(query) {
  return request({
    url: `/website/honor/list`,
    method: 'get',
	params:query
  })
}

export function salesRankWebSite(query) {
  return request({
    url: `oper/authenticate/salesRankWebSite`,
   method: 'post',
   data:query
  })
}

export function zxDetail(query) {
  return childRequest({
    url: `oper/userDynamic/findById`,
    method: 'get',
	params:query
  })
}
export function findByCondition(query) {
  return childRequest({
    url: `oper/news/findByCondition`,
    method: 'get',
	params:query
  })
}

export function zxCarousel(query) {
  return childRequest({
    url: `oper/carousel/all`,
    method: 'get',
	params:query
  })
}
export function signingNewList(query) {
  return request({
    url: `oper/signing/newList`,
    method: 'post',
	data:query
  })
}

export function carouselList(query) {
  return childRequest({
    url: `oper/carousel/website`,
    method: 'get',
	params:query
  })
}



// WEBPACK FOOTER //
// ./src/api/webstation.js